<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/G8ldE/media/FC-9781398446137.jpg?1670934200995" alt="This image is the cover for the book Mirror of hope"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mirror of hope
      </h1>
      <p class="bookDescription body article font2">
        <p>Marcos was an accomplished painter who had given up on love and had decided that he was going to grow old and maybe wise but being wise was not guaranteed after what he had just experienced. His parents were his bench mark for love and marriage he held his life up to, his mum was always trying to find him the “one”, his dad knew his wife meant well but couldn’t stop herself. He knew he loved painting and could often dream in colour, he dreamt about fairies, sandy beaches, the circus and other wonderful things but one constant in his dreams was something he would never be able to tell anyone about, or they would definitely have the men in white coats with strait jackets come and bundle him in the back of an ambulance or ensure he had no sharp knives around to do a Van Gogh. Was he going mad or does love make you crazy? Queen said it right in “Crazy little thing called love”. Come and see what or who Marcos was going crazy for. Would you hold out for the love of your life, do you even believe there is only one person for you?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ann Obayuwana
      </h2>
      
      <p class="authorDescription body article">Ann Obayuwana was born in Liverpool and lived there till she was 14 years old. She moved with her family to Skelmersdale and then later moved to London. After a lifetime of working in social housing, her last job was being the head of resident service at YMCALSW. She and her husband moved back to her birthplace. During lockdown, Ann thought back to her school days and how she used to love writing stories. So, she thought she would set herself a challenge and found she still enjoyed writing. Now she hopes others will enjoy it too.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?aa94e15a